<template functional>
  <div class="column">
    <SmartLink
      :native="false"
      :to="props.url"
      :target="props.target"
      :rel="props.rel"
      :aria-label="props.url"
      data-analytics-id="homepage-link"
      data-analytics-action="content-banner"
      :data-analytics-label="props.url"
      :data-analytics-record-id="props.id"
      v-on="listeners.click ? { click: listeners.click } : null"
    >
      <nuxt-img
        loading="lazy"
        :src="props.imgSrc"
        :alt="props.altText"
        :data-billboard-id="props.id"
      />
    </SmartLink>
  </div>
</template>

<script>
export default {
  name: 'Banner',

  props: {
    id: {
      type: [Number, String],
      required: true
    },

    url: {
      type: String,
      required: true
    },

    imgSrc: {
      type: String,
      required: true
    },

    altText: {
      type: String,
      required: true
    },

    target: {
      type: [Boolean, String],
      default: false
    },

    rel: {
      type: [Boolean, String],
      default: false
    }
  }
}
</script>

<style scoped>
img {
  width: 100%;
}
</style>
